declare var window: any;

class IndexedDB {
  public indexedDB: any;
  private CURRENT_VERSION = 2;
  private DATABASE_NAME: string = 'MEETINGMEMO';
  constructor() {
    this.indexedDB =
      window.indexedDB ||
      window.mozIndexedDB ||
      window.webkitIndexedDB ||
      window.msIndexedDB ||
      window.shimIndexedDB;

    const open = this.indexedDB.open(this.DATABASE_NAME, this.CURRENT_VERSION);

    // triggered when database opened is blank or database ID is renewed
    open.onupgradeneeded = (event: any) => {
      const db = open.result;
      // create the schemas
      // テーブルのようなもの

      if (event.oldVersion === 0) {
        db.createObjectStore('auth', { keyPath: 'id' });
        db.createObjectStore('language', { keyPath: 'id' });
      }
    };
  }

  public put(id: string, data: object, storeTitle: string): Promise<any> {
    const open = this.indexedDB.open(this.DATABASE_NAME, this.CURRENT_VERSION);

    return new Promise((resolve, reject) => {
      open.onsuccess = () => {
        const db = open.result;
        const tx = db.transaction(storeTitle, 'readwrite');
        const store = tx.objectStore(storeTitle);

        store.put({ id, data });

        tx.oncomplete = () => {
          console.log('IndexedDB', 'data successfully put');
          db.close();
          resolve();
        };
      };

      open.onerror = () => {
        alert('IndexedDBの接続に失敗しました');
        reject();
      };
    });
  }

  public get(id: string, storeTitle: string): Promise<any> {
    const open = this.indexedDB.open(this.DATABASE_NAME, this.CURRENT_VERSION);
    return new Promise((resolve, reject) => {
      open.onsuccess = () => {
        const db = open.result;
        const tx = db.transaction(storeTitle, 'readwrite');
        const store = tx.objectStore(storeTitle);
        const getData = store.get(id);

        getData.onsuccess = () => {
          console.log('IndexedDB got:', getData.result);
          if (getData.result !== undefined) {
            const data = getData.result.data;
            resolve(data);
          } else {
            console.log('IndexedDB:', 'no data stored.');
            resolve();
          }
        };

        tx.oncomplete = () => {
          db.close();
        };
      };

      open.onerror = () => {
        alert('IndexedDBの接続に失敗しました');
        reject();
      };
    });
  }

  public remove(storeTitle: string): Promise<any> {
    const open = this.indexedDB.open(this.DATABASE_NAME, this.CURRENT_VERSION);
    return new Promise((resolve, reject) => {
      open.onsuccess = () => {
        const db = open.result;
        const tx = db.transaction(storeTitle, 'readwrite');
        const store = tx.objectStore(storeTitle);
        const clearData = store.clear();

        clearData.onsuccess = () => {
          console.log('IndexedDB Auth cleared');
          resolve();
        };

        tx.oncomplete = () => {
          db.close();
        };
      };

      open.onerror = () => {
        alert('IndexedDBの接続に失敗しました');
        reject();
      };
    });
  }
}

export default IndexedDB;



// WEBPACK FOOTER //
// ./src/common/IndexedDB.ts